import { setData } from '../../context/AppCreateReferralProvider';
export default function clearDraftState(dispatchCreateReferral) {
  dispatchCreateReferral(setData({
    draftState: null
  }));
}
;
//# sourceMappingURL=clearDraftState.js.map